import { xs_languageCode } from "..";
import { formatDate, formatDateWithWeekDay, getDBTimestampFromDate } from "./utils";

export function parseAgendaStreamingData(data) {
    if ((data.agenda || null) === null) {
        return {};
    }
    
    const agenda = JSON.parse(data.agenda);
    const started = data.started?JSON.parse(data.started) : null;
    const agendaStreamingSports = {};

    agenda.ms && Object.values(agenda.ms).forEach(function(match) {
        const sportId = match.is;
        let asSport = agendaStreamingSports[sportId];
        if (asSport === undefined) {
            asSport = {
                sportId: sportId, 
                sportDesc: agenda.sds[sportId][xs_languageCode], 
                tournamentsById: {}, 
                earlierTs: null
            };
            agendaStreamingSports[sportId] = asSport;
        }

        const tournamentId = match.it
        let asTournament = agendaStreamingSports[sportId].tournamentsById[tournamentId];
        if (asTournament == null) {
            asTournament = {
                tournamentId: tournamentId, 
                tournamentDesc: agenda.tds[tournamentId][xs_languageCode], 
                sportRef: sportId,
                categoryRef: match.ic,
                iconClassSport: agenda.icos && agenda.icos[sportId],
                iconClassCountry: agenda.icoc && agenda.icoc[match.ic],
                matchesById: {},
                earlierTs: null
            };
            agendaStreamingSports[sportId].tournamentsById[tournamentId] = asTournament;
        }

        const matchId = match.bid
        let asMatch = asTournament.matchesById[matchId];

        if (asMatch === undefined) {
            const _date = formatDate(match.ts);
            const timestamp = new Date(_date.year,_date.month-1,_date.day,_date.hours,_date.minutes,_date.seconds);
            const strStarted = started?.ms?.[`${match.p}_${match.a}`]?.str ?? null;
            const strOver = (timestamp < (new Date())) && !strStarted;

           const desc = match.dsl[xs_languageCode];
            const split = desc && desc.split(' - ');
            asMatch = {
                matchId: matchId,
                id: match.bid,
                team1: split && split[0],
                team2: split && split[1],
                date: _date,
                ...match,
                str: strStarted,
                strOver: strOver,
                timestamp: timestamp,
                iconClassSport: agenda.icos && agenda.icos[sportId],
                iconClassCountry: agenda.icoc && agenda.icoc[match.ic],
                sportRef: sportId,
                categoryRef: match.ic
            };
            asTournament.matchesById[matchId] = asMatch;

            if (asTournament.earlierTs === null || (asTournament.earlierTs > timestamp)) {
                asTournament.earlierTs = timestamp
            }
            
            if (asSport.earlierTs === null || (asSport.earlierTs > timestamp)) {
                asSport.earlierTs = timestamp
            }
        }
    });

    Object.entries(agendaStreamingSports).forEach(function([ks, vs]) {
        Object.entries(agendaStreamingSports[ks].tournamentsById).forEach(function([kt, vt]) {
            vt.hasMatches = Object.values(vt.matchesById).find(m => !m.strOver) != null;
            if (vt.hasMatches) {
                vs.hasTournaments = true;
            }
            vs.tournamentsById = Object.values(vs.tournamentsById).sort(function(a, b) {
                return a.earlierTs - b.earlierTs
            });

            vt.matchesById = Object.values(vt.matchesById).sort(function(a, b) {
                return a.timestamp - b.timestamp
            });
        });
    });

    const asSorted = Object.values(agendaStreamingSports).sort(function(a, b) {
        return a.earlierTs - b.earlierTs;
    });

    return asSorted;
}

export function parseAgendaStreamingDataByDate(data) {
    const sports = parseAgendaStreamingData(data);

    const dates = new Map();
    sports.forEach(s => {
        const date = s.earlierTs.getDate();
        if (!dates.has(date)) {
            const timestamp = getDBTimestampFromDate(s.earlierTs);
            s.formattedDate = formatDateWithWeekDay(timestamp).day;
            dates.set(date, []);
        }
        dates.get(date).push(s);
    });
 
    return Array.from(dates.values());
}
